import { useEffect, useState } from "react";

export default function LayoutTabsCustomLable({ title, tables }) {
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const count = tables.reduce((count, table) => {
      return count + table.activeOrders.filter((o) => o.orderStatus === "Pending").length;
    }, 0);

    setPendingCount(count);
  }, [tables]);

  return (
    <div className="flex items-center gap-2">
      <span>{title}</span>
      {pendingCount > 0 && (
        <div className="text-xs bg-red-600 px-2 py-1 rounded table-blink">{pendingCount}</div>
      )}
    </div>
  );
}
